'use strict';

(function () {
  var module = angular.module('client.components');

  module.directive('noCopy', function () {
    return {
      restrict: 'A',
      scope: {},
      link: function postLink(scope, elem, attrs) {
        if (elem) {
          let quizElement = elem[0];
          const block = (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.clipboardData && e.clipboardData.setData("text/plain", "");
          };

          quizElement.addEventListener("copy", block, true);
          quizElement.addEventListener("cut", block, true);
          quizElement.addEventListener("contextmenu", (e) => e.preventDefault(), true);
          quizElement.addEventListener("selectstart", (e) => e.preventDefault(), true);
        }
      }
    };
  });

})();
